import React, { useCallback } from 'react';
import { MessageResponse } from '@ujet/websdk-headless';
import { Typography } from 'gd-design-library';

export const Notification = ({ message }: { message: MessageResponse }): React.ReactElement => {
  const getNotificationText = useCallback((message: MessageResponse) => {
    switch (message.event) {
    case 'escalationStarted':
      return 'We are connecting you with a human agent';
    case 'memberLeft':
      return `${message.memberName} just left the conversation`;
    case 'escalationAccepted':
      return `${(message.to_agent as { name: string }).name} just joined the conversation`;
    default:
      return;
    }
  }, []);

  return <Typography variant='caption' align='center'>{getNotificationText(message)}</Typography>;
};
